import React from 'react';
import { withRouter } from 'react-router'
import VerificationForm from './VerificationForm';
import { withApollo, compose } from 'react-apollo';
import { findDocumentType } from '../utils/documentTypes'
import { CheckDocuments } from '../mutations/CheckDocuments'
import { UpdateDocument } from "../mutations/UpdateDocument";

class VerifyDocument extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      forms: this.initialFormValues(this.props)
    };
  }
  componentWillReceiveProps(nextProps){
    if(!this.props.documents || this.props.documents.length === 0){
      this.setState({forms: this.initialFormValues(nextProps)})
    }
  }

  initialFormValues(props) {
    const forms = {}
    props.documents.forEach((document) => {
          forms[document.id] = JSON.parse(document.formAttributes)
    })
    return forms
  }

  handleNext = (isFormValid) => {
    const promises = this.props.documents.map((document) => {
      if(!findDocumentType(document.type).formComponent) return true
      return this.props.client.mutate({
        mutation: UpdateDocument,
        variables: {
          input: {
            document: {
              id: document.id,
              formAttributes: JSON.stringify(this.state.forms[document.id])
            }
          }
        }
      })
    })
    Promise.all(promises).then(() => {
      this.setState({ loading: true })
      this.props.client.mutate({
        mutation: CheckDocuments,
        variables: {
          input: {
            claimId: this.props.claim.id,
            taskId: this.props.match.params.id
          }
        }
      }).then(() => {
        this.setState({ loading: false })
        this.props.onSaved()
      }).catch((error) => {
        console.error(error)
        this.setState({ loading: false })
      })
    })
    //TODO: Handle errors + callback on success

  }

  handleDataChange = (documentId, name, value) => {
    const updatedForm = {
      ...this.state.forms[documentId],
      [name]: value
    }
    this.setState({
      forms: Object.assign(
        {},
        this.state.forms,
        {[documentId] : updatedForm}
      )
    })
  }

  handleLabelClick = () => {
    this.setState({ isLabeleditable: true })
  }

  handleLabelBlur = () => {
    this.setState({ isLabeleditable: false })
  }


  render = () => (
    <VerificationForm
      values={this.state.forms}
      onDataChange={this.handleDataChange}
      onNextClick={this.handleNext.bind(this)}
      onLabelBlur={this.handleLabelBlur}
      onLabelClick={this.handleLabelClick}
      history={this.props.history}
      idFormValues={this.state.id}
      boardingPassFormValues={this.state.boardingPass}
      documents={this.props.documents}
      claim={this.props.claim}
      loading={this.props.loading || this.state.loading}
      senderType={this.props.senderType}
    />
  )
}

const VerifyDocumentTaskWithData = compose(
  withApollo
)(VerifyDocument)

export default withRouter(VerifyDocumentTaskWithData);



// WEBPACK FOOTER //
// ./src/component/VerifyDocument.js